export default {
    props: {
        aggregates: Array,
        attributes: Object,
        columns: Array,
        command: String | Array,
        editable: Function,
        editor: Function,
        encoded: Boolean,
        field: String,
        filterable: Boolean | Object,
        filterableCellDataSource: {
            type: Object,
            default: undefined,
            kComposite: 'filterable.cell.dataSource'
        },
        filterableCellDataTextField: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.dataTextField'
        },
        filterableCellDelay: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.delay'
        },
        filterableCellInputWidth: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.inputWidth'
        },
        filterableCellSuggestionOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.suggestionOperator'
        },
        filterableCellMinLength: {
            type: Number,
            default: undefined,
            kComposite: 'filterable.cell.minLength'
        },
        filterableCellEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.cell.enabled'
        },
        filterableCellOperator: {
            type: String,
            default: undefined,
            kComposite: 'filterable.cell.operator'
        },
        filterableCellShowOperators: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.cell.showOperators'
        },
        filterableCellTemplate: {
            type: Function,
            default: undefined,
            kComposite: 'filterable.cell.template'
        },
        filterableMulti: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.multi'
        },
        filterableDataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'filterable.dataSource'
        },
        filterableCheckAll: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.checkAll'
        },
        filterableItemTemplate: {
            type: Function,
            default: undefined,
            kComposite: 'filterable.itemTemplate'
        },
        filterableOperators: {
            type: Object,
            default: undefined,
            kComposite: 'filterable.operators'
        },
        filterableSearch: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.search'
        },
        filterableIgnoreCase: {
            type: Boolean,
            default: undefined,
            kComposite: 'filterable.ignoreCase'
        },
        filterableUi: {
            type: [String, Function],
            default: undefined,
            kComposite: 'filterable.ui'
        },
        footerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'footerAttributes'
        },
        footerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'footerTemplate'
        },
        format: String,
        groupable: Boolean | Object,
        groupableSortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'groupable.sort.compare'
        },
        groupableSortDir: {
            type: String,
            default: undefined,
            kComposite: 'groupable.sort.dir'
        },
        groupHeaderTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupHeaderTemplate'
        },
        groupHeaderColumnTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupHeaderColumnTemplate'
        },
        groupFooterTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'groupFooterTemplate'
        },
        headerAttributes: {
            type: Object,
            default: undefined,
            kComposite: 'headerAttributes'
        },
        headerTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'headerTemplate'
        },
        hidden: {
            type: Boolean,
            default: undefined,
            kComposite: 'hidden'
        },
        locked: Boolean,
        lockable: Boolean,
        media: String,
        minResizableWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minResizableWidth'
        },
        minScreenWidth: {
            type: Number,
            default: undefined,
            kComposite: 'minScreenWidth'
        },
        selectable: Boolean,
        sortable: Boolean,
        sortableCompare: {
            type: Function,
            default: undefined,
            kComposite: 'sortable.compare'
        },
        sortableInitialDirection: {
            type: String,
            default: undefined,
            kComposite: 'sortable.initialDirection'
        },
        template: String | Function,
        title: String,
        width: String | Number,
        values: Array,
        menu: Boolean
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridColumn/Columns.js